import { FeatureFlag } from '@ps/web-core-enums';
import classNames from 'clsx';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import CoachMark from '@swf/components/CoachMark/CoachMark';
import useFeature from '@swf/core/hooks/useFeature';
import type { RootState } from '@swf/core/store';

import useGetCurrentClub from '../../../hooks/useGetCurrentClub';
import { useHomeGamesWidget } from '../../../model';
import { ClubRoute, HGOnboarding, UserClubRole } from '../../../types/common';
import JoinGameCoach from '../../CoachMark/JoinClub/JoinGameCoach';

import styles from './GameTileCoachMark.scss';

const hiddenElementClassName = 'game-tile-coach-mark';

const GameTileCoachMark = () => {
  const { widgetDispatch, widgetSelect } = useHomeGamesWidget();
  const ref = useRef<HTMLDivElement>(null);
  const { clubId, section } = useParams<{ clubId: string; section: string }>();
  const { roleForUser } = useGetCurrentClub(clubId);
  const joinClubOBEnabled = useFeature(FeatureFlag.PKRHomeGamesOnboardingJoinClub);
  const isMember = roleForUser === UserClubRole.Member;
  const isLobbyPage = section === ClubRoute.Lobby;
  const isFirstElement = document.querySelector(`.${hiddenElementClassName}`) === ref.current;
  const joinClubOnboardingCompleted = useSelector((rootState: RootState) =>
    widgetSelect.localStorageItem(rootState, `onboarding[${HGOnboarding.JoinClub}]`)
  );
  const showCoachMark =
    !joinClubOnboardingCompleted && joinClubOBEnabled && isMember && isLobbyPage && isFirstElement;
  const handleCoachMarkDismiss = () =>
    widgetDispatch.setLocalStorageItem({
      onboarding: { [HGOnboarding.JoinClub]: true }
    });

  if (showCoachMark) {
    return (
      <div
        onClick={(event) => {
          event.preventDefault();
        }}
        className={classNames(styles.container, hiddenElementClassName)}
        ref={ref}
      >
        <CoachMark
          onClickAway={handleCoachMarkDismiss}
          className={styles.coachMark}
          content={
            <JoinGameCoach className={styles.coachMark} onDismiss={handleCoachMarkDismiss} />
          }
          placement="right"
        >
          <div className={styles.inner} />
        </CoachMark>
      </div>
    );
  }

  return null;
};

export default GameTileCoachMark;
